import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { SORT_TYPES } from '@savgroup-front-common/constants/shared/sort';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  apiCall,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SearchOrders,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}orders/search`;

export interface SearchMarketplaceOrdersRequestArgs {
  searchQuery: string;
  page: number;
}

export const searchMarketplaceOrdersRequest = ({
  searchQuery,
  page,
}: SearchMarketplaceOrdersRequestArgs): ApiRequestDescriptor => ({
  url: buildUrl(
    ENDPOINT,
    {
      term: searchQuery.trim(),
      page,
      pageSize: 32,
    },
    { encode: true, arrayFormat: 'brackets' },
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export enum OrderType {
  ORDER = 'Order',
  DELIVERY_NOTE = 'DeliveryNote',
  SALES_RECEIPT = 'SalesReceipt',
}

export enum GET_ORDERS_BY_QUERY_CONTEXT {
  GLOBAL_SEARCH = 'GlobalSearch',
  CREATE_FILE = 'CreateFile',
}

export interface GetOrdersByQueryArgs {
  page?: number;
  pageSize?: number;
  query: string;
  sort?: SORT_TYPES;
  isDescending?: boolean;
  sellerId?: string;
  context?: GET_ORDERS_BY_QUERY_CONTEXT;
  orderType?: OrderType;
}

async function getOrdersByQuery({
  page = 1,
  pageSize = 10,
  isDescending,
  query,
  sort,
  sellerId,
  context,
  orderType,
}: GetOrdersByQueryArgs): Promise<
  BackResponse<SearchOrders[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, {
      page,
      pageSize,
      term: query,
      sort,
      isDescending,
      sellerId,
      context,
      orderType,
    });

    return await apiCall<BackResponse<SearchOrders[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getOrdersByQuery;
